import { FieldType } from "../common/constants";
import { CATEGORY_DOC } from "./category";

export const COURSE_DOC = {
    fields: [
        {
            id: "name",
            type: FieldType.TEXT,
            required: true,
            label: "Courses.Name",
            width: "1/2",
            localizable: false,
            title: true,
        },
        {
            id: "shortPromo",
            type: FieldType.HTML,
            required: true,
            label: "Courses.ShortPromo",
            localizable: false,
            //subtitle: true,
        },
        {
            id: "picture",
            type: FieldType.ASSET,
            filter: "image/*",
            required: true,
            label: "Courses.Picture",
            localizable: false,
            picture: true,
        },
        {
            id: "shortDescription",
            type: FieldType.TEXT,
            required: true,
            width: "1/2",
            label: "Courses.ShortDescription",
            localizable: false,
        },
        {
            id: "description",
            type: FieldType.HTML,
            required: true,
            label: "Courses.Description",
            localizable: false,
        },
        {
            id: "price",
            type: FieldType.PRICE,
            required: true,
            label: "Courses.Price",
            localizable: false,
        },
        {
            id: "hidden",
            type: FieldType.CHECKBOX,
            label: "Courses.Hidden",
            localizable: false,
        },
        {
            id: "category",
            type: FieldType.REFERENCE,
            collection: "categories",
            form: CATEGORY_DOC,
            label: "Courses.Category",
            localizable: false,
        },
        {
            id: "online",
            type: FieldType.CHECKBOX,
            label: "Courses.Online",
            localizable: false,
        },
    ],
};
